module.exports = __webpack_public_path__ + "img/plus-icon.7df482ad.svg";